/**
 * Favorite Locations List Component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import FavoriteLocationCard from './FavoriteLocationCard';
import EmptyState from '../common/EmptyState';
import './FavoriteLocationsList.css';

const FavoriteLocationsList = ({ locations, onEdit, onDelete }) => {
  const { t } = useTranslation('common');

  if (!locations || locations.length === 0) {
    return (
      <EmptyState
        variant="locations"
        title={t('empty_states.no_locations_title')}
        description={t('empty_states.no_locations_description')}
      />
    );
  }

  return (
    <div className="favorite-locations-list">
      {locations.map(location => (
        <FavoriteLocationCard
          key={location.id}
          location={location}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default FavoriteLocationsList;
